"use client";

export { default as LinkWithLang } from "@stadium/shared/src/components/link-with-lang";
